module.exports = __webpack_public_path__ + "media/images/landkit/icons/social/pinterest-bf59543b2d74e7c51013bb68ddaa0a98.svg";